export default __webpack_public_path__ + "static/faq@2x-b9fb866028ea27a8e9a8f9f7f30ef87d.png";